// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__31INU","input-select":"Input_input-select__1yl-N"};